import PropTypes from 'prop-types';

import './pseudo-link.scss';

const PseudoLink = ({ title, link }) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = link;
  };

  return (
    <span
      onClick={(e) => onClick(e)}
      className="pseudo-link"
      role="link"
      tabIndex="0">
      {title}
    </span>
  );
};

PseudoLink.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default PseudoLink;
